import React, { useEffect, useRef, useState } from 'react'
import { useNavigate, useParams } from 'react-router'
import { useGet, usePost } from '../../Api';
import { WebLayout } from '../../Components/WebLayout';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Slider from 'react-slick';
import { faAddressCard, faArrowAltCircleLeft, faArrowAltCircleRight, faBathtub, faBed, faCheckCircle, faCity, faEnvelope, faFlag, faGlobe, faGlobeEurope, faHomeAlt, faLocationPin, faUser } from '@fortawesome/free-solid-svg-icons';
import { faFacebook, faSquarePinterest, faTwitter, faWhatsapp, faXTwitter } from '@fortawesome/free-brands-svg-icons';
import './style.css'
import '../../Components/FavoriteButton/style.css'
import DatePicker from 'react-datepicker';
import { male1 } from '../../Assets/images';
import { base_url } from '../../Api/apiConfig';
import { useNotification } from '../../Components/GlobalNotification';

import FavoriteButton from '../../Components/FavoriteButton';
import CustomModal from '../../Components/CustomModal';

export const ListingDetail = () => {
    const { showNotification } = useNotification();
    const { id } = useParams();
    const [listingDetail, setListingDetail] = useState();
    const { ApiData: ListDetailData, loading: ListDetailLoading, error: ListDetailError, get: GetListDetail } = useGet(`/frontend/listings/${id}`);
    const { ApiData: SubmitBookingData, loading: SubmitBookingLoading, error: SubmitBookingError, post: GetSubmitBooking } = usePost(`/submitBooking`);
    const [checkInDate, setCheckInDate] = useState(null);
    const [checkOutDate, setCheckOutDate] = useState(null);
    const checkInRef = useRef(null);
    const checkOutRef = useRef(null);
    const [isOpen, setIsOpen] = useState(false);
    const [adults, setAdults] = useState(0);
    const [children, setChildren] = useState(0);
    const dropdownRef = useRef(null);

    const totalGuests = adults + children;

    const getAuthToken = () => localStorage.getItem('login');

    const isUserLoggedIn = () => {
        const token = getAuthToken();
        return token && token !== 'null' && token !== 'undefined' && token.trim() !== '';
    };

    const handleCheckInDateChange = (date) => {
        setCheckInDate(date);
        if (checkOutDate && date && checkOutDate < date) {
            setCheckOutDate(null);
        }
        setTimeout(() => checkInRef.current?.setOpen(false, true), 100);
    };

    const handleCheckOutDateChange = (date) => {
        setCheckOutDate(date);
        setTimeout(() => checkOutRef.current?.setOpen(false, true), 100);
    };


    useEffect(() => {
        GetListDetail()
    }, [id])

    useEffect(() => {
        if (ListDetailData) {
            setListingDetail(ListDetailData?.data?.listing)
        }
    }, [ListDetailData])


    const CustomArrow = ({ direction, onClick }) => (
        <div className={`custom-arrow custom-arrow-${direction}`} onClick={onClick}>
            <FontAwesomeIcon icon={direction === 'left' ? faArrowAltCircleLeft : faArrowAltCircleRight} />
        </div>
    )

    const imageCount = listingDetail?.media?.length || 0;
    const hasMultipleImages = imageCount > 1;

    const settings = {
        dots: hasMultipleImages,
        infinite: hasMultipleImages,
        autoplay: hasMultipleImages,
        autoplaySpeed: 3000,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: hasMultipleImages,
        prevArrow: hasMultipleImages ? <CustomArrow direction="left" /> : null,
        nextArrow: hasMultipleImages ? <CustomArrow direction="right" /> : null,
    };





    const toggleDropdown = () => setIsOpen(!isOpen);

    const handleClickOutside = (e) => {
        if (dropdownRef.current && !dropdownRef.current.contains(e.target)) {
            setIsOpen(false);
        }
    };

    useEffect(() => {
        document.addEventListener('mousedown', handleClickOutside);
        return () => document.removeEventListener('mousedown', handleClickOutside);
    }, []);

    const [availabilityMessage, setAvailabilityMessage] = useState('');
    const [isCheckingAvailability, setIsCheckingAvailability] = useState(false);
    const [availabilityDetail, setAvailabilityDetail] = useState(null);



    useEffect(() => {
        const checkAvailability = async () => {
            if (!checkInDate || !checkOutDate || !id || totalGuests === 0) {
                setAvailabilityDetail(null);
                return;
            }

            const checkInStr = checkInDate.toISOString().split('T')[0];
            const checkOutStr = checkOutDate.toISOString().split('T')[0];
            const token = getAuthToken();

            setIsCheckingAvailability(true);
            setAvailabilityMessage('');
            setAvailabilityDetail(null);

            try {
                const response = await fetch(`${base_url}/filter/check-availability/${id}/${checkInStr}/${checkOutStr}/${totalGuests}`, {
                    headers: {
                        Accept: 'application/json',
                        'Content-Type': 'application/json',
                        ...(token ? { Authorization: `Bearer ${token}` } : {}),
                    },
                });

                const result = await response.json().catch(() => null);

                if (!response.ok || !result) {
                    const errorMessage = result?.message || result?.error || 'Unable to check availability for the selected dates.';
                    setAvailabilityMessage(`⚠️ ${errorMessage}`);
                    setAvailabilityDetail(null);
                    return;
                }

                if (result?.["send-in-controller"]) {
                    setAvailabilityDetail(result["send-in-controller"]);
                }

                setAvailabilityMessage(result?.message || '');
            } catch (err) {
                console.error("Error checking availability:", err);
                setAvailabilityMessage("⚠️ Could not check availability. Please try again.");
                setAvailabilityDetail(null);
            } finally {
                setIsCheckingAvailability(false);
            }
        };

        checkAvailability();
    }, [checkInDate, checkOutDate, totalGuests, id]);


    const [showMessage, setShowMessage] = useState(false);
    const navigate = useNavigate();

    const Continue = () => {
        setShowMessage(false)
        navigate('/login')
    }

    const validateBookingForm = () => {
        if (!isUserLoggedIn()) {
            return { valid: false, reason: 'auth' };
        }

        if (!checkInDate || !checkOutDate) {
            return { valid: false, reason: 'dates' };
        }

        if (totalGuests === 0) {
            return { valid: false, reason: 'guests' };
        }

        if (!availabilityDetail) {
            return { valid: false, reason: 'availability' };
        }

        return { valid: true };
    };

    const handleSubmitBook = () => {
        const validation = validateBookingForm();

        if (!validation.valid) {
            if (validation.reason === 'auth') {
                setShowMessage(true);
                return;
            }

            if (validation.reason === 'dates') {
                showNotification({ type: 'error', title: 'Error', message: 'Please select check-in and check-out dates.' });
                return;
            }

            if (validation.reason === 'guests') {
                showNotification({ type: 'error', title: 'Error', message: 'Please add at least one guest.' });
                return;
            }

            if (validation.reason === 'availability') {
                showNotification({ type: 'error', title: 'Error', message: 'Please wait for availability confirmation or select different dates.' });
                return;
            }

            return;
        }

        GetSubmitBooking(availabilityDetail);
    };


    useEffect(() => {
        if (SubmitBookingData) {
            showNotification({ type: 'success', title: 'Success', message: SubmitBookingData?.message || 'Booking request submitted successfully.' });

            // Reset the booking form so the user cannot click the button again
            // on the same selection. The backend duplicate check prevents actual
            // duplicate rows if the user re-selects the same dates.
            setCheckInDate(null);
            setCheckOutDate(null);
            setAdults(0);
            setChildren(0);
            setAvailabilityDetail(null);
            setAvailabilityMessage('');
        }
    }, [SubmitBookingData])

    useEffect(() => {
        if (SubmitBookingError) {
            const errorMessage = SubmitBookingError?.message || SubmitBookingError?.error || 'Booking request failed. Please try again.';
            showNotification({ type: 'error', title: 'Error', message: errorMessage });
        }
    }, [SubmitBookingError])

    return (
        <WebLayout>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-9 mb-4'>
                        <div className='propertyDetail'>
                            <div className='detailTitle'>
                                <h1>{listingDetail?.title}</h1>
                            </div>
                            <div className='propertyMeta'>
                                <span className='priceBox'>USD {listingDetail?.pricing?.nightly}</span>
                                <span className='perNight'>Per Night</span>
                                <span className='isFav'>
                                    <FavoriteButton listingId={id} />
                                </span>
                            </div>
                            <div className='propertySlider'>
                                <Slider {...settings}>
                                    {listingDetail?.media?.map((item, idx) => (
                                        <div className='properImage' key={idx}>
                                            <img src={item?.image_url} alt='propertyImage' className='mw-100' />
                                        </div>
                                    ))}
                                </Slider>
                            </div>

                            {/* detail data  */}

                            <div className='detailData'>
                                <div className='title-head'>
                                    <h3>Property Details</h3>
                                </div>
                                <div className='row'>
                                    <div className='col-md-12 mb-4'>
                                        <div className='iconBox'>
                                            <div className='iconData'>
                                                <FontAwesomeIcon icon={faLocationPin}></FontAwesomeIcon>
                                            </div>
                                            <div className='iconDetai'>
                                                <p><span><strong>Location:</strong>{listingDetail?.location?.address}</span></p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='col-md-4 mb-4'>
                                        <div className='iconBox'>
                                            <div className='iconData'>
                                                <FontAwesomeIcon icon={faHomeAlt}></FontAwesomeIcon>
                                            </div>
                                            <div className='iconDetai'>
                                                <p><span><strong>Type:</strong>{listingDetail?.type_of_listing?.listing_name}</span></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4 mb-4'>
                                        <div className='iconBox'>
                                            <div className='iconData'>
                                                <FontAwesomeIcon icon={faBathtub}></FontAwesomeIcon>
                                            </div>
                                            <div className='iconDetai'>
                                                <p><span><strong>Bathrooms:</strong>{listingDetail?.bathrooms}</span></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4 mb-4'>
                                        <div className='iconBox'>
                                            <div className='iconData'>
                                                <FontAwesomeIcon icon={faBed}></FontAwesomeIcon>
                                            </div>
                                            <div className='iconDetai'>
                                                <p><span><strong>Bedrooms:</strong>{listingDetail?.bedrooms?.length}</span></p>
                                            </div>
                                        </div>
                                    </div>


                                    <div className='col-md-4 mb-4'>
                                        <div className='iconBox'>
                                            <div className='iconData'>
                                                <FontAwesomeIcon icon={faCity}></FontAwesomeIcon>
                                            </div>
                                            <div className='iconDetai'>
                                                <p><span><strong>City:</strong>{listingDetail?.location?.city}</span></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4 mb-4'>
                                        <div className='iconBox'>
                                            <div className='iconData'>
                                                <FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon>
                                            </div>
                                            <div className='iconDetai'>
                                                <p><span><strong>Country:</strong>{listingDetail?.location?.country}</span></p>
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-4 mb-4'>
                                        <div className='iconBox'>
                                            <div className='iconData'>
                                                <FontAwesomeIcon icon={faGlobe}></FontAwesomeIcon>
                                            </div>
                                            <div className='iconDetai'>
                                                <p><span><strong>Area:</strong>{listingDetail?.size}<sup>SF</sup></span></p>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>


                            {/* features  */}


                            <div className='detailData'>
                                <div className='title-head'>
                                    <h3>Features</h3>
                                </div>
                                <div className='row'>
                                    {
                                        listingDetail?.amenities?.map((item, index) => (
                                            <div className='col-md-3 mb-4' key={`amenity-${index}`}>
                                                <div className='iconBox'>
                                                    <div className='iconData'>
                                                        <FontAwesomeIcon icon={faCheckCircle}></FontAwesomeIcon>
                                                    </div>
                                                    <div className='iconDetai'>
                                                        <p><span>{item?.amenity_name}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>

                                <div className='title-head mt-4'>
                                    <h3>Facilities</h3>
                                </div>
                                <div className='row'>
                                    {
                                        listingDetail?.facilities?.map((item, index) => (
                                            <div className='col-md-3 mb-4' key={`facility-${index}`}>
                                                <div className='iconBox'>
                                                    <div className='iconData'>
                                                        <FontAwesomeIcon icon={faCheckCircle}></FontAwesomeIcon>
                                                    </div>
                                                    <div className='iconDetai'>
                                                        <p><span>{item?.facility_name}</span></p>
                                                    </div>
                                                </div>
                                            </div>
                                        ))
                                    }
                                </div>


                            </div>

                            {/* description box  */}

                            <div className='detailData'>
                                <div className='title-head'>
                                    <h3>Property Description
                                    </h3>
                                </div>
                                <div className='row'>

                                    <div className='col-md-12 mb-4'>
                                        <div className='iconBox'>
                                            <div className='iconDetaitData'>
                                                <p>{listingDetail?.description}</p>
                                            </div>
                                        </div>
                                    </div>

                                </div>


                            </div>
                        </div>
                    </div>
                    <div className='col-md-3 mb-4'>
                        <div className='right-widget'>
                            <div class="sidebar-title">
                                <h3>Share this Property</h3>
                            </div>
                            <div className="share-this-page-widget">
                                <ul>
                                    <li>
                                        <a
                                            target="_blank"
                                            href="https://www.facebook.com/sharer/sharer.php?u=https://vacationrentals.kayifi.com/listing/beautiful-house/"
                                        >
                                            <div className="icon facebook">
                                                <FontAwesomeIcon icon={faFacebook} />
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            target="_blank"
                                            href="http://twitter.com/intent/tweet?text=beautiful house&url=https://vacationrentals.kayifi.com/listing/beautiful-house/"
                                        >
                                            <div className="icon twitter">
                                                <FontAwesomeIcon icon={faXTwitter} />
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            target="_blank"
                                            href="http://www.linkedin.com/shareArticle?mini=true&url=https://vacationrentals.kayifi.com/listing/beautiful-house/"
                                        >
                                            <div className="icon linkedin">
                                                <FontAwesomeIcon icon={faTwitter} />
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            target="_blank"
                                            href="http://pinterest.com/pin/create/bookmarklet/?url=https://vacationrentals.kayifi.com/listing/beautiful-house/&is_video=false&description=test&media=https://vacationrentals.kayifi.com/wp-content/uploads/2023/10/th-3.jpg"
                                        >
                                            <div className="icon pinterest">
                                                <FontAwesomeIcon icon={faSquarePinterest} />
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a
                                            target="_blank"
                                            href="https://web.whatsapp.com/send?text=https://vacationrentals.kayifi.com/listing/beautiful-house/"
                                        >
                                            <div className="icon whatsapp">
                                                <FontAwesomeIcon icon={faWhatsapp} />
                                            </div>
                                        </a>
                                    </li>
                                    <li>
                                        <a href="javascript:window.location.href = 'mailto:?subject=' + decodeURIComponent('beautiful house').replace('&', '%26') + '&body=' + decodeURIComponent('https://vacationrentals.kayifi.com/listing/beautiful-house/')">
                                            <div className="icon email">
                                                <FontAwesomeIcon icon={faEnvelope} />
                                            </div>
                                        </a>
                                    </li>
                                </ul>
                            </div>
                            <div class="mr-opti block-body-sidebar">
                                <span class="item-price">
                                    <sup>$</sup>{listingDetail?.pricing?.nightly}<sub>/night</sub>
                                </span>


                            </div>
                            <div className='bookingForm mt-3'>
                                <div className='row'>
                                    <div className='col-md-12'>
                                        {availabilityMessage && (
                                            <div className={`alert ${availabilityMessage.startsWith('⚠️') || availabilityMessage.toLowerCase().includes('must be') || availabilityMessage.toLowerCase().includes('not available') ? 'alert-danger' : 'alert-success'}`}>
                                                {availabilityMessage}
                                            </div>
                                        )}
                                    </div>

                                    <div className='col-md-6 mb-3'>
                                        <div className="form-group">
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <DatePicker
                                                    ref={checkInRef}
                                                    selected={checkInDate}
                                                    shouldCloseOnSelect
                                                    preventOpenOnFocus
                                                    onInputClick={() => {
                                                        checkOutRef.current?.setOpen(false);
                                                        checkInRef.current?.setOpen(true);
                                                    }}
                                                    onClickOutside={() => checkInRef.current?.setOpen(false)}
                                                    onChange={handleCheckInDateChange}
                                                    selectsStart
                                                    startDate={checkInDate}
                                                    endDate={checkOutDate}
                                                    placeholderText="check in"
                                                    className="input-field border"
                                                    dateFormat="MM/dd/yyyy"
                                                    minDate={new Date()}
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    {/* Check-Out */}
                                    <div className={`col-md-6 mb-3`}>
                                        <div className="form-group">
                                            <div onClick={(e) => e.stopPropagation()}>
                                                <DatePicker
                                                    ref={checkOutRef}
                                                    selected={checkOutDate}
                                                    shouldCloseOnSelect
                                                    preventOpenOnFocus
                                                    onInputClick={() => {
                                                        checkInRef.current?.setOpen(false);
                                                        checkOutRef.current?.setOpen(true);
                                                    }}
                                                    onClickOutside={() => checkOutRef.current?.setOpen(false)}
                                                    onChange={handleCheckOutDateChange}
                                                    selectsEnd
                                                    startDate={checkInDate}
                                                    endDate={checkOutDate}
                                                    minDate={checkInDate || new Date()}
                                                    placeholderText="check out"
                                                    className="input-field border"
                                                    dateFormat="MM/dd/yyyy"
                                                    disabled={!checkInDate}
                                                />
                                            </div>
                                        </div>
                                    </div>

                                    <div className='col-md-12 mb-3'>
                                        <div className="position-relative" ref={dropdownRef}>
                                            {/* Trigger Box */}
                                            <div
                                                className="border rounded p-2 d-flex align-items-center justify-content-between"
                                                onClick={toggleDropdown}
                                                style={{ width: '100%', cursor: 'pointer' }}
                                            >
                                                <span className='d-flex gap-2 align-items-center'> <FontAwesomeIcon icon={faUser} />{totalGuests}</span>
                                            </div>

                                            {/* Dropdown */}
                                            {isOpen && (
                                                <div
                                                    className="border rounded p-3 bg-white mt-1"
                                                    style={{
                                                        position: 'absolute',
                                                        zIndex: 1000,
                                                        width: '100%',
                                                        borderColor: '#f7941d'
                                                    }}
                                                >
                                                    {/* Adults */}
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <div><strong>{adults}</strong> Adults</div>
                                                        <div className="btn-group btn-group-sm">
                                                            <button
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => setAdults(Math.max(0, adults - 1))}
                                                            >−</button>
                                                            <button
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => setAdults(adults + 1)}
                                                            >+</button>
                                                        </div>
                                                    </div>

                                                    {/* Children */}
                                                    <div className="d-flex justify-content-between align-items-center mb-3">
                                                        <div><strong>{children}</strong> Children</div>
                                                        <div className="btn-group btn-group-sm">
                                                            <button
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => setChildren(Math.max(0, children - 1))}
                                                            >−</button>
                                                            <button
                                                                className="btn btn-outline-secondary"
                                                                onClick={() => setChildren(children + 1)}
                                                            >+</button>
                                                        </div>
                                                    </div>

                                                    {/* Apply Button */}
                                                    <button
                                                        className="btn btn-primary btn-block font-weight-bold"
                                                        onClick={() => setIsOpen(false)}
                                                    >
                                                        Apply
                                                    </button>
                                                </div>
                                            )}
                                        </div>

                                    </div>
                                    <div className='col-md-12 mb-3'>
                                        <textarea name='description' className='form-control border' placeholder='Introduce yourself to the host'></textarea>

                                    </div>
                                    <div className='col-md-12 mb-3' >
                                        <button
                                            type='button'
                                            className='btn-primary btn w-100'
                                            onClick={() => { handleSubmitBook() }}
                                            disabled={SubmitBookingLoading || isCheckingAvailability}
                                        >
                                            {SubmitBookingLoading
                                                ? 'Submitting...'
                                                : isCheckingAvailability
                                                    ? 'Checking availability...'
                                                    : 'Request to Book'}
                                        </button>
                                    </div>
                                </div>
                            </div>

                            <div className='userDetailBox'>
                                <div className='row align-items-center'>
                                    <div className='col-md-3 mb-3'>
                                        <div className='imageIcon'>
                                            <img src={male1} alt={listingDetail?.user?.name} />
                                        </div>
                                    </div>
                                    <div className='col-md-9 mb-3'>
                                        <p className='text-capitalize mb-0'>{listingDetail?.user?.name}</p>
                                    </div>
                                    <div className='col-md-12 mb-3'>
                                        <div className='userMetaData'>
                                            <p><span><FontAwesomeIcon icon={faEnvelope} /></span><a href={listingDetail?.user?.email}>{listingDetail?.user?.email}</a></p>
                                            <p><span><FontAwesomeIcon icon={faAddressCard} /></span><a>{listingDetail?.location?.city}, {listingDetail?.location?.country}</a></p>
                                        </div>
                                    </div>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </div>

            <CustomModal show={showMessage} close={() => { setShowMessage(false) }} login action={Continue} heading='Please login or signup to book.' />

        </WebLayout >
    )
}
